import {createLazyFileRoute} from '@tanstack/react-router'

import Flight from '@/views/Flight/Flight'

export const Route = createLazyFileRoute('/_flight/flights/')({
  component: Flight,
})
